









import {
    Component,
    Vue,
    Advisor,
    ModelProp,
    ComponentStyle,
    ComponentStyleDefinition,
    VueComponent,
    InjectComponent,
    ComponentConfig,
    QAFlowStepsNavigation, Provide
} from "@zoovu/runner-browser-api";
import {
    ColorsConfiguration,
    FontsConfiguration,
    StandardTextsConfiguration,
    CustomCSSConfiguration,
    TopProductConfiguration,
    ProductButtonConfiguration,
    PdfConfiguration,
    AnimationsAndTransitionsConfiguration
} from "../configuration";

@Component({})
export default class AdvisorView extends Vue {
    @InjectComponent("QuestionnaireView")
    questionnaireView: VueComponent;

    @InjectComponent("ComparisonView")
    comparisonView: VueComponent;

    @InjectComponent("ResultsSectionView")
    resultsSectionView: VueComponent;

    @InjectComponent("PdfContentView")
    pdfContentView: VueComponent;

    @ComponentStyle()
    componentStyle: ComponentStyleDefinition;

    @ComponentConfig(ColorsConfiguration)
    colors: ColorsConfiguration;

    @ComponentConfig(FontsConfiguration)
    fonts: FontsConfiguration;

    @ComponentConfig(StandardTextsConfiguration)
    standardTexts: StandardTextsConfiguration;

    @ComponentConfig(CustomCSSConfiguration)
    customCssConfiguration: CustomCSSConfiguration;

    @ComponentConfig(TopProductConfiguration)
    topProductConfiguration: TopProductConfiguration;

    @ComponentConfig(ProductButtonConfiguration)
    productButtonConfiguration: ProductButtonConfiguration;

    @ComponentConfig(PdfConfiguration)
    pdfConfiguration: PdfConfiguration;

    @ComponentConfig(AnimationsAndTransitionsConfiguration)
    animationsAndTransitionsConfiguration: AnimationsAndTransitionsConfiguration;

    @ModelProp()
    advisor: Advisor;

    pdfMarkupIsReady = false;

    get isPdfMarkupShown(): boolean {
        return this.pdfConfiguration && this.pdfConfiguration.enabled && this.pdfMarkupIsReady;
    }

    // temporary: AdvisorLocalizationSettingsDefinition is not exported by RBA unfortunately
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    @Provide()
    get localizationSettings() {
        return this.advisor.localizationSettings;
    }

    get navigation(): QAFlowStepsNavigation {
        return this.advisor.flowStepsNavigation;
    }

    mounted(): void {
        this.$root.$on("toggle-pdf-markup", (status: boolean) => {
            this.pdfMarkupIsReady = status;
        });
    }
}
